import React, { useState, useEffect } from "react";
import { Input, Form, Col, Row, Button, Select } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import { defaultValidateMessages } from "./Helper";
import Replace2x from "util/Extensions/ReplaceExtension";

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
  },
};

const EInvoiceAddForm = (props) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [eInvoiceRequirements, setEInvoiceRequirements] = useState([]);
  const [activeEInvoiceServiceId, setActiveEInvoiceServiceId] = useState();
  const [tenantTitle, setTenantTitle] = useState();
  const [vkn, setVkn] = useState();
  const [taxOffice, setTaxOffice] = useState();
  const [address, setAddress] = useState();
  const [city, setCity] = useState();
  const [state, setState] = useState();
  const [eInvoiceServiceSelect, setEInvoiceServiceSelect] = useState({
    data: [],
    loading: false,
  });

  useEffect(() => {
    getEInvoiceInfoRequirements();
    getNotAddedEInvoiceService();
  }, []);

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
    }
  }, [props.data]);
  const getEInvoiceInfoRequirements = () => {
    RequestHandler.get(`/EInvoiceInfoRequirement`).then((response) => {
      if (Array.isArray(response)) {
        setEInvoiceRequirements(response);
      }
    });
    const tenantId = Replace2x(localStorage.getItem("tenantId"));
    RequestHandler.get(`/Tenant/getbyid/${tenantId}`).then((response) => {
      setTenantTitle(response.fullName);
      setVkn(response.vkn);
      setTaxOffice(response.taxOffice);
      setAddress(response.address);
      setCity(response.city);
      setState(response.state);
    });
  };

  const onFinish = (values) => {
    RequestHandler.post(`/EinvoiceInfo`, values).then((response) => {
      setLoading(false);
      if (response.success) {
        form.resetFields();
        if (props.onSuccess) props.onSuccess();
      }
    });
  };

  const onFinishFailed = (errorInfo) => {
    setLoading(false);
  };
  const onChangeAddress = (e) => {
    setAddress(e.target.value);
  };
  const onChangeCity = (e) => {
    setCity(e.target.value);
  };
  const onChangeState = (e) => {
    setState(e.target.value);
  };
  
  const onChangeTenantTitle = (e) => {
    setTenantTitle(e.target.value);
  };
  const onChangeTaxOffice = (e) => {
    setTaxOffice(e.target.value);
  };
  const onChangeVkn = (e) => {
    setVkn(e.target.value);
  };

  const getNotAddedEInvoiceService = () => {
    setEInvoiceServiceSelect({
      ...eInvoiceServiceSelect,
      loading: true,
    });
    RequestHandler.get(`/EInvoiceInfo/GetAddedEInvoiceService?$select=id,name`).then(
      (response) => {
        setEInvoiceServiceSelect({
          data: response,
          loading: false,
        });
      }
    );
  };
  const eInvoiceRequirement = eInvoiceRequirements.find(
    (x) => x.eInvoiceProgramId === activeEInvoiceServiceId
  );
  return (
    <Form
      {...formItemLayout}
      validateMessages={defaultValidateMessages}
      form={form}
      name="eInvoiceAdd"
      initialValues={{
        remember: true,
      }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      fields={[
        { name: "tenantTitle", value: tenantTitle?.toString() === "" ? null : tenantTitle?.toString()},
        { name: "vkn",value: vkn?.toString() === "" ? null : vkn?.toString()},
        { name: "taxOffice", value: taxOffice?.toString() === "" ? null : taxOffice?.toString()},
        { name: "address", value: address?.toString() === "" ? null : address?.toString()},
        { name: "city", value: city?.toString() === "" ? null : city?.toString()},
        { name: "state", value: state?.toString() === "" ? null : state?.toString()},
      ]}
    >
      <Row>
        <Col span={24}>

        <Form.Item name="eInvoiceProgramId" label="E-Fatura Sağlayıcı" rules={[{ required: true }]}>
                <Select
                  allowClear
                  showSearch
                  placeholder="Seçiniz"
                  filterOption={(input, option) =>
                    option.children
                      .toLocaleLowerCase("tr-TR")
                      .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                  }
                  onChange={(value) => setActiveEInvoiceServiceId(value)}
                  loading={eInvoiceServiceSelect.loading}
                >
                  {eInvoiceServiceSelect.data.map((item) => (
                    <Select.Option key={item.id} value={item.id}>
                      {item.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
        {eInvoiceRequirement && (
            <>

          {
            eInvoiceRequirement.isUserNameRequired && (
              <Form.Item
              label={eInvoiceRequirement.userNameLabel}
              name="userName"
              rules={[{ required: true, whitespace: true }]}
              >
                <Input />
              </Form.Item>
            )}
             {eInvoiceRequirement.isPasswordRequired && (

                <Form.Item
                  label={"Şifre"}
                  name="password"
                  rules={[{ required: true, whitespace: true }]}
                >
                  <Input.Password autoComplete="new-password" />
                </Form.Item>
             )}

            {
            eInvoiceRequirement.isEArchiveUserNameRequired && (
              <Form.Item
              label={eInvoiceRequirement.eArchiveUserNameLabel}
              name="eArchiveUserName"
              rules={[{ required: true, whitespace: true }]}
              >
                <Input />
              </Form.Item>
            )}
             {eInvoiceRequirement.isEArchivePasswordRequired && (

                <Form.Item
                  label={"Şifre"}
                  name="eArchivePassword"
                  rules={[{ required: true, whitespace: true }]}
                >
                  <Input.Password autoComplete="new-password" />
                </Form.Item>
             )}
             {
              eInvoiceRequirement.isErpCodeRequired && (
                <Form.Item
                label={"Erp Kodu"}
                name="erpCode"
                rules={[{ required: true, whitespace: true }]}
                >
                  <Input />
                </Form.Item>
            )}

                <Form.Item
                label={"Vergi Dairesi"}
                name="taxOffice"
                rules={[{ required: true, whitespace: true }]}
                >
                  <Input onChange={onChangeTaxOffice}/>
                </Form.Item>

                <Form.Item
                label={"Vkn"}
                name="vkn"
                rules={[
                  { required: true, whitespace: true }]}
                >
                  <Input
                  type="number"
                  onKeyDown={(evt) =>evt.key === "e" && evt.preventDefault()}
                  onChange={onChangeVkn}
                  />
                </Form.Item>

                <Form.Item
                label={"Adres"}
                name="address"
                rules={[{ required: true, whitespace: true }]}
                >
                  <Input onChange={onChangeAddress}/>
                </Form.Item>

                <Form.Item
                label={"İl"}
                name="city"
                rules={[{ required: true, whitespace: true }]}
                >
                  <Input onChange={onChangeCity}/>
                </Form.Item>

                <Form.Item
                label={"İlçe"}
                name="state"
                rules={[{ required: true, whitespace: true }]}
                >
                  <Input onChange={onChangeState}/>
                </Form.Item>

                <Form.Item
                label={"Şirket Ünvanı"}
                name="tenantTitle"
                rules={[{ required: true, whitespace: true }]}
                >
                  <Input onChange={onChangeTenantTitle}/>
                </Form.Item>

                <Form.Item
                label={"Fatura Kodu"}
                name="eInvoiceCode"
                rules={[{ required: true, whitespace: true }]}
                >
                  <Input  maxLength={3} />
                </Form.Item>

              {eInvoiceRequirement.isXsltNameRequired && (

                <Form.Item
                label={"Varsayılan Şablon Adı"}
                name="xsltName"
                rules={[{ required: true, whitespace: true }]}
                >
                  <Input maxLength={100} />
                </Form.Item>
            )}
              {eInvoiceRequirement.isEArchiveXsltNameRequired && (

                <Form.Item
                label={"Varsayılan E-Arşiv Şablon Adı"}
                name="eArchiveXsltName"
                rules={[{ required: true, whitespace: true }]}
                >
                  <Input maxLength={100} />
                </Form.Item>
            )}
                </>
        )}
          <Col style={{ textAlign: "right" }}>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              htmlType="submit"
              onClick={() => setLoading(true)}
              loading={loading}
            >
              Ekle
            </Button>
          </Col>
        </Col>
      </Row>
    </Form>
  );
};
export default EInvoiceAddForm;
